import { Api } from '../api';
import { payments } from '../endpoints';
import {
  CheckLimitRequest,
  CheckLimitResponse,
  ExternalRequest,
  GetRequisitesResponse,
  PostRequisitesRequest,
  PostRequisitesResponse,
} from './models';

export class PaymentsApi extends Api {
  static getRequisites = (signal?: AbortSignal) => this.get<GetRequisitesResponse[]>({ url: payments.requisites(), signal: signal });

  static checkLimit = (request: CheckLimitRequest, signal?: AbortSignal) =>
    this.post<CheckLimitRequest, CheckLimitResponse>({ url: payments.checkLimit(), data: request, signal: signal });

  static postRequisites = (request: PostRequisitesRequest, signal?: AbortSignal) =>
    this.post<PostRequisitesRequest, PostRequisitesResponse>({ url: payments.requisites(), data: request, signal: signal });

  static deleteRequisites = (id: string, signal?: AbortSignal) => this.delete<null>({ url: payments.deleteRequisites(id), signal: signal });

  static external = (request: ExternalRequest, signal?: AbortSignal) =>
    this.post<ExternalRequest, PostRequisitesResponse>({ url: payments.external(), data: request, signal: signal });

  static internal = (request: ExternalRequest, signal?: AbortSignal) =>
    this.post<ExternalRequest, PostRequisitesResponse>({ url: payments.internal(), data: request, signal: signal });
}
